export enum SKUDO_PERMISSION_ID {
  ROUTE_GENERAL = 'route__/main/general',
  ROUTE_CAMPAIGNS = 'route__/main/campaigns',
  ROUTE_OFFERS = 'route__/main/offers',
  ROUTE_PROVIDERS = 'route__/main/providers',
  ROUTE_REPORTING = 'route__/main/reporting',
  ROUTE_EVENTS = 'route__/main/events',
  ROUTE_FRAUD = 'route__/main/fraud',

  UI_CAMPAIGNS_CLONE = 'ui__campaignsClone',
  UI_CAMPAIGNS_CREATE = 'ui__campaignsCreate',
  UI_CAMPAIGNS_DELETE = 'ui__campaignsDelete',
  UI_CAMPAIGNS_ARCHIVE = 'ui__campaignsArchive',
  UI_CAMPAIGNS_EDIT = 'ui__campaignsEdit',
  UI_CAMPAIGNS_VIEW = 'ui__campaignsView',

  UI_OFFERS_CLONE = 'ui__offersClone',
  UI_OFFERS_CREATE = 'ui__offersCreate',
  UI_OFFERS_DELETE = 'ui__offersDelete',
  UI_OFFERS_ARCHIVE = 'ui__offersArchive',
  UI_OFFERS_EDIT = 'ui__offersEdit',
  UI_OFFERS_VIEW = 'ui__offersView',
  UI_OFFERS_ADD_PROVIDER = 'ui__offersAddProvider',
  UI_OFFERS_EDIT_PROVIDER = 'ui__offersEditProvider',
  UI_OFFERS_DELETE_PROVIDER = 'ui__offersDeleteProvider',
  UI_OFFERS_CREATE_FRAUD = 'ui__offersCreateFraud',
  UI_OFFERS_EDIT_FRAUD = 'ui__offersEditFraud',

  UI_PROVIDERS_CREATE = 'ui__providersCreate',
  UI_PROVIDERS_DELETE = 'ui__providersDelete',
  UI_PROVIDERS_EDIT = 'ui__providersEdit',
  UI_PROVIDERS_VIEW = 'ui__providersView',

  UI_EVENTS_CREATE = 'ui__eventsCreate',
  UI_EVENTS_DELETE = 'ui__eventsDelete',
  UI_EVENTS_EDIT = 'ui__eventsEdit',
  UI_EVENTS_VIEW = 'ui__eventsView',

  UI_FRAUD_TEMPLATES_CREATE = 'ui__fraudTemplatesCreate',
  UI_FRAUD_TEMPLATES_DELETE = 'ui__fraudTemplatesDelete',
  UI_FRAUD_TEMPLATES_EDIT = 'ui__fraudTemplatesEdit',
  UI_FRAUD_TEMPLATES_VIEW = 'ui__fraudTemplatesView',
}
